import {css} from 'lit';
export const styles = css`:host {
  --count-color: var(--dark-text-secondary);
  --count-font-size: var(--font-size-sm);
  --count-padding: 4px;
  --count-label-display: none;
  --button-color-active: var(--dark-text-secondary);
  --count-background: var(--contrast-light);
  --button-color-hover: var(--primary);
  --button-color: var(--dark-text);
  --button-margin: 0 0 0 16px;
  --button-icon-size: 24px;
  --badge-color: var(--secondary);
  --avatar-size: 40px;
}

.left {
  margin-right: 16px;
}

.right {
  display: flex;
  align-items: center;
}

.bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: var(--avatar-size);
  margin-top: 4px;
}

.bottom ef-label {
    margin-top: 4px;
    margin-bottom: 4px;
  }

ef-label {
  --text-primary: var(--count-color);
  --background-primary: var(--count-background);
  --font-size-primary: var(--count-font-size);

  margin: var(--count-margin);
  padding: var(--count-padding);
}

ef-label .count-label {
    display: var(--count-label-display);
    margin-left: 4px;
  }

.action-wrapper {
  display: flex;
  align-items: center;
}

.action-wrapper ef-tooltip {
    --trigger-padding: 0;
  }

.action-wrapper ef-badge {
    --secondary: var(--badge-color);

    margin-right: 4px;
  }

.action-wrapper ef-icon {
    font-size: var(--button-icon-size);
  }

.action-wrapper button {
    padding: 0;
    border: none;
    background-color: transparent;
    color: var(--button-color);
    line-height: 1;
  }

@media (hover: hover) {
      .action-wrapper button:hover {
        color: var(--button-color-hover);
      }
    }

.action-wrapper button:active {
      color: var(--button-color-active);
    }

:host([layout='column']) {
  --count-margin: 8px 0 0 0;

  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}

:host([layout='row']) {
  --count-margin: 0 16px 0 0;
}

:host([layout='row']) .left {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }

slot[name='avatars'] + .action-wrapper {
  margin: var(--button-margin);
}
`;
export default styles;
